import angular from 'angular';

angular.module('cloudX').directive('validateStructuredCommunication', function() {
  return {
    restrict: 'A',
    require: ['?ngModel', '^?bindErrors'],
    link: function(scope, element, attrs, ctrls) {
      var ngModel = ctrls[0];
      var bindErrors = ctrls[1];
      if (!ngModel) return; // do nothing if no ng-model

      ngModel.$validators.structuredCommunication = function(modelValue, viewValue) {
        var value = modelValue || viewValue || null;
        if (value === null) return true; //Allow null and empty values
        //Replace invalid characters and spaces
        value = value.replace(/[^0-9]/g, '');
        if (value.length !== 12) return false;
        var toTest = value.substr(0, 10);
        var mod = parseInt(toTest) % 97 || 97;
        return mod === parseInt(value.substr(10));
      };
      if (bindErrors) {
        bindErrors.addError('structuredCommunication', 6017);
      }
    },
  };
});
